import dayjs from "dayjs";

import { useAuth } from "context/providers/auth";
import useLocalStorage from "hooks/useLocalStorage";
import CalendarIssues from "components/CalendarIssues";

const Calendar = () => {
  const {
    state: {
      user: { company },
    },
  } = useAuth();

  const [view_type, setViewType] = useLocalStorage(
    `${company?.id}_main_calendar_view_type`,
    "month"
  );

  const [date, setDate] = useLocalStorage(
    `${company?.id}_main_calendar_date`,
    dayjs().startOf("month").format()
  );

  const [worker_id, setWorkerId] = useLocalStorage(
    `${company?.id}_main_calendar_worker_id`,
    null
  );

  return (
    <CalendarIssues
      view_type={view_type}
      worker_id={worker_id}
      issue_id={null}
      date={dayjs(date)}
      show_in_modal={false}
      onWorkerChange={(id) => setWorkerId(id)}
      onDateChange={(date) => setDate(date)}
      onViewTypeChange={(vt) => setViewType(vt)}
      origin_source="Z okna głównego"
    />
  );
};

export default Calendar;
